import _get from 'lodash/get';

export function updateRefundMethods(prevMethods = [], methodData = null) {
  const methodSlug = _get(methodData, 'payment_method', '');
  const prevData = prevMethods.find(method => {
    const slug = _get(method, 'payment_method', '');
    return slug === methodSlug;
  });
  const isPrevDefault = _get(prevData, 'is_default', false);
  const isCurrDefault = _get(methodData, 'is_default', false);
  const flipDefaults = isCurrDefault !== isPrevDefault;

  return prevMethods.map(method => {
    const slug = _get(method, 'payment_method', '');
    const isDefault = _get(method, 'is_default', false);
    let dataset = { ...method };
    if (slug === methodSlug) {
      dataset = { ...dataset, ...methodData };
    }
    if (flipDefaults) {
      dataset.is_default = !isDefault;
    }
    return dataset;
  });
}
